import { JsonObject } from "json2typescript";

@JsonObject('ClientMarketingRequestModel')
export class ClientMarketingRequestModel implements ClientMarketingRequestModel {
  AcceptEmailMarketing?: boolean;
  AcceptMarketing: boolean;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
